

































import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'
import Component from 'vue-class-component'
import ScrollView from '@/components/ScrollView.vue'
import Contact from '@/views/app/management/collections/components/Contact.vue'
import { IResidentContact } from '@zunta/configurations'

@Component({
  components: { Contact, ScrollView }
})
export default class CollectionContacts extends CollectionSharedFunctions {
  showAllContact: boolean = false

  get filteredResidentContacts () {
    if (this.showAllContact) {
      return this.residentContacts
    }
    return this.residentContacts.filter((contact: IResidentContact) =>
      (contact.email || contact.mobilePhone || contact.officePhone || contact.homePhone) &&
      ((contact.firstName && contact.firstName !== '-') || (contact.lastName && contact.lastName !== '-'))
    )
  }

  toggleShowAllContacts () {
    this.showAllContact = !this.showAllContact
  }

  mounted () {
    this.$watch('currentTaskIndex', () => {
      this.showAllContact = false
    })
  }
}
